/* This file is autogenerated, see readme.md for instructions */
import BracketsCancelSvgIcon from '@bloomreach/banana-theme/icons/brackets-cancel.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const BracketsCancelIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <BracketsCancelSvgIcon />
    </Icon>
  );
});

BracketsCancelIcon.displayName = 'BracketsCancelIcon';

export default BracketsCancelIcon;
